import { render, staticRenderFns } from "./CopyModesSelector.vue?vue&type=template&id=3dc21bc9&scoped=true&"
import script from "./CopyModesSelector.vue?vue&type=script&lang=js&"
export * from "./CopyModesSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc21bc9",
  null
  
)

export default component.exports